module.exports = __webpack_public_path__ + "img/france.c307991b.jpg";